import Grouping from './grouping';

export default class GroupingQuiz extends Grouping {
  constructor(obj) {
    super(obj);
  }

  get route() {
    return {
      name: 'groupings#show',
      params: {
        groupingId: this.id,
      },
    };
  }

  completedState(states, store) {
    if (states.length !== this.flashcardAssociations.length) {
      return false;
    }
    const unansweredFlashcardStatus = store.getters['flashcardStatuses/unansweredFlashcardStatus'];
    const answeredFlashcardStates = states.filter(state => state.flashcardStatusId !== unansweredFlashcardStatus?.id);
    return states.length === answeredFlashcardStates.length;
  }

  cardMetadata() {
    if (this.flashcardAssociations?.length > 0) {
      return `${this.flashcardAssociations.length} Questions`;
    }
  }

  inProgressState(states, store) {
    const unansweredFlashcardStatus = store.getters['flashcardStatuses/unansweredFlashcardStatus'];
    const answeredFlashcardStates = states.filter(state => state.flashcardStatusId !== unansweredFlashcardStatus?.id);
    return answeredFlashcardStates > 0 && states.length !== answeredFlashcardStates;
  }

  states(store) {
    return this.flashcardAssociations
      .map(aa => store.getters['flashcardStates/flashcardStates'][`${aa.assetBId}-asset-association-${aa.id}`])
      .filter(state => state);
  }
}